import { booleanColumn } from '@/shared/grids/columns/booleanColumn';
import { dateColumn } from '@/shared/grids/columns/dateColumn';
import { idColumn } from '@/shared/grids/columns/idColumn';
import { notesExcerptColumn } from '@/shared/grids/columns/notesExcerptColumn';
import { notesIconColumn } from '@/shared/grids/columns/notesIconColumn';
import { textColumn } from '@/shared/grids/columns/textColumn';
import { ClientType, SmartTaskType, UpdateOnCompletion } from '@/shared/types/enum';
import { GridSettings } from '@/shared/types/grid';
import { enumOptions } from '@/shared/utils/enum';

import { SmartTaskView } from '@prisma/client';

export const smartTaskGrid: GridSettings<SmartTaskView> = {
  defaultSort: {
    task: 'asc',
  },
  columns: [
    idColumn(),
    notesIconColumn({
      field: 'hasNotes',
    }),
    booleanColumn({
      header: 'Enabled',
      field: 'enabled',
    }),
    textColumn({
      header: 'Task',
      field: 'task',
      width: 300,
    }),
    textColumn({
      header: 'Service',
      field: 'serviceId',
      width: 200,
      extra: {
        displayField: 'serviceName',
        sortField: 'serviceName',
        filter: {
          lookup: 'Service',
        },
      },
    }),
    textColumn({
      header: 'Type',
      field: 'clientTypeName',
      extra: {
        filter: {
          options: enumOptions(ClientType),
        },
      },
    }),
    booleanColumn({
      header: 'Records Required',
      field: 'recordsRequired',
      iconClass: 'fa-solid fa-folder-closed',
    }),
    textColumn({
      header: 'Trigger',
      field: 'smartTaskType',
      template: `\${window.formatters.formatSmartTaskType(smartTaskType)}`,
      extra: {
        filter: {
          options: enumOptions(SmartTaskType),
        },
      },
    }),
    textColumn({
      header: 'Update',
      field: 'updateOnCompletion',
      template: `\${if(updateOnCompletion)}\${window.formatters.formatUpdateOnCompletion(updateOnCompletion)}\${else}<span class="text-more-muted">Not set</span>\${/if}`,
      extra: {
        filter: {
          options: enumOptions(UpdateOnCompletion),
        },
      },
    }),
    dateColumn({
      header: 'Added',
      field: 'createdTime',
      visible: false,
    }),
    textColumn({
      header: 'Added By',
      field: 'createdByUserId',
      visible: false,
      extra: {
        displayField: 'createdByUserName',
        sortField: 'createdByUserName',
        filter: {
          lookup: 'MemberView',
        },
      },
    }),
    notesExcerptColumn({
      field: 'notesExcerpt',
    }),
    textColumn({
      header: 'Assign To',
      field: 'assignedToUserId',
      emptyText: 'Account Manager',
      extra: {
        displayField: 'assignedToUserName',
        sortField: 'assignedToUserName',
        filter: {
          lookup: 'MemberView',
        },
      },
    }),
  ],
};
